<template>
	<v-container>
		<v-card v-if="config.forms && config.forms.myAccount">
			<v-card-text>
				<SchemaToForm
					:debug="(false)"
					:schema="config.forms.myAccount"
					v-model="formData"
					@valid="formValid = true"
					@invalid="formValid = false"
				>
				</SchemaToForm>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="success"
					:loading="saveLoading"
					:disabled="saveLoading || !formValid"
					@click="save"
					text
				>
					Tallenna
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-container>
</template>

<script>

import { mapState } from 'vuex'
import SchemaToForm from '@/components/SchemaToForm'

export default {
	name: 'MyAccount',
	components: {
		SchemaToForm,
	},
	data: () => ({
		formData: {},
		saveLoading: false,
		formValid: false,
	}),
	computed: {
		...mapState([
			'user',
			'config',
		]),
	},
	methods: {
		save () {
			this.saveLoading = true

			this.$api.Me.doRequest({
				method: 'POST',
				body: this.formData,
			}).on('done', () => {
				// Refresh caches
				this.$api.Config.doRequest()
				this.$api.Me.doRequest()
			}).on('finish', () => {
				this.saveLoading = false
			})
		},
	},
};
</script>
